module.exports = function (Swiper) {

    const BRswiper = new Swiper('.business-related-carousel', {
        // Optional parameters
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: '.slider-btn--next',
            prevEl: '.slider-btn--prev',
            hiddenClass: 'slider-btn--hidden',
            disabledClass: 'slider-btn--disabled',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            976: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            1440: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
        },
    });

    const BRSwiperDestroyer = jQuery('.business-related-carousel-destroyer');

    if (BRSwiperDestroyer.length) {
        BRSwiperDestroyer.on('click', function () {
            BRswiper.destroy();
            jQuery('.business-related-carousel-navigation').addClass('hidden');
            jQuery('.business-related-carousel-wrapper').addClass('grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-5');
            jQuery('.business-related-carousel-wrapper').removeClass('swiper-wrapper');
        });
    }

    const ToDoSlider = new Swiper('.ToDoSlider', {
        // Optional parameters
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: '.slider-btn--next',
            prevEl: '.slider-btn--prev',
            hiddenClass: 'slider-btn--hidden',
            disabledClass: 'slider-btn--disabled',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            976: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            1440: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
        },
    });

    const ToDoSliderDestroyer = jQuery('.ToDoSliderDestroyer');

    if (ToDoSliderDestroyer.length) {
        ToDoSliderDestroyer.on('click', function () {
            ToDoSlider.destroy();
            jQuery('.ToDoSliderNavigation').addClass('hidden');
            jQuery('.ToDoSliderWrapper').addClass('grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-5');
            jQuery('.ToDoSliderWrapper').removeClass('swiper-wrapper');
        });
    }


    const aboutSwipers = new Swiper('.about-areas-carousel', {
        // Optional parameters
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: '.slider-btn--next',
            prevEl: '.slider-btn--prev',
            hiddenClass: 'slider-btn--hidden',
            disabledClass: 'slider-btn--disabled',
        },

        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 1,
            },
            1440: {
                slidesPerView: 2,
            },
        },
    });

    const aboutPersonSwipers = new Swiper('.about-people-carousel', {
        // Optional parameters
        loop: false,
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 20,

        // Navigation arrows
        navigation: {
            nextEl: '.slider-btn--next',
            prevEl: '.slider-btn--prev',
            hiddenClass: 'slider-btn--hidden',
            disabledClass: 'slider-btn--disabled',
        },
        breakpoints: {
            640: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3.2,
            },
            1440: {
                slidesPerView: 4.5,
            },
        },
    });


    const homeTextSlider = new Swiper('.homepage-text-slider', {
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });

    const homeEventsCarousel = new Swiper('.homepage-events-slider', {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: '.event-nav-next',
            prevEl: '.event-nav-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
                allowTouchMove: false,
                autoplay: false,
            },
        },
    });
}